module.exports = __webpack_public_path__ + "img/avator3.95b7c927.png";